var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media"},[(_vm.editable)?_c('x-icon',{staticClass:"custom-class",attrs:{"size":"1.5x"},on:{"click":_vm.removeMedia}}):_vm._e(),(_vm.getMedia(_vm.id))?_c('img',{attrs:{"src":_vm.getMedia(_vm.id).thumbnail,"width":_vm.getMedia(_vm.id).width,"height":_vm.getMedia(_vm.id).height}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }